module.exports = __webpack_public_path__ + "img/S3.2179780e.png";